<script setup>
import { router } from '@inertiajs/vue3';
import moment from 'moment';
import { BIconXCircleFill } from 'bootstrap-icons-vue';
import { ref } from 'vue';
import JetButton from '@/Jetstream/Button.vue';
import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue';
import JetDialogModal from '@/Jetstream/DialogModal.vue';

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const urlNamePrefix = organisation ? "gi." : "";

const deleteConfirm = ref(false);

const props = defineProps({
    comment: Object,
    loggedInUserId: Number,
    filters: Object,
    contains_draft_auditor_comment: Boolean,
    auditorSession: Object,
    pastToolkit: Boolean
});

const filepath = '/storage/';

const userFirstInitial = props.comment.auditor_name.charAt(0).toUpperCase();

//const created_at = moment(String(props.comment.created_at)).format('DD/MM/YYYY HH:mm')
const UserAvatar = props.comment.profile_photo_path ? '/storage/'+ props.comment.profile_photo_path : 'https://ui-avatars.com/api/?name='+userFirstInitial+'&color=7F9CF5&background=EBF4FF';

function formatDate(created_at) {
    const created_at_formatted = moment(String(created_at)).format('DD/MM/YYYY HH:mm');
    return created_at_formatted;
}


const  editAuditorComment = () => {

    router.post(route(urlNamePrefix+'auditor.auditor-comments.toggle-edit', {'subdomain':'auditor'}),
        {
            id: props.comment.id,
            filters: props.filters
        },
        {
            preserveState: true,
            preserveScroll: true,
        });
}


const deleteComment = () => {

    router.post(route(urlNamePrefix+'auditor.auditor-comments.destroy', {'subdomain':'auditor'}),
        {
            id: props.comment.id,
            filters: props.filters
        },
        {
            preserveState: true,
            preserveScroll: true,
        });
        deleteConfirm.value = false;
}

const deleteModal = () => {
    deleteConfirm.value = true;
};

const closeModal = () => {
    deleteConfirm.value = false;
};

</script>

<template>

    <div v-if="comment.draft == 0" class="flex py-2 flex-row">
        <div class="flex flex-row mr-3" v-if="!pastToolkit">
            <BIconXCircleFill v-if="comment.auditor_code_id == auditorSession.auditor_code_id" class="delete-comment relative left-3 top-0 h-15 w-15 text-xl border-2 border-white rounded-lg" style="color:red;cursor: pointer;" v-on:click="deleteModal();"/>
            <img :src="UserAvatar" :alt="comment.first_name + ' ' + comment.last_name" class="h-16 w-16 rounded-full object-cover user-avatar max-w-max" />
        </div>
        <div class="flex flex-col pt-1 justify-start">
            <div v-if="!comment.is_deleted" v-html="comment.comment" class="flex flex-col flex-wrap text-left" />
            <div v-if="comment.is_deleted" class="flex flex-col flex-wrap"><span class="text-sm text-slate-500">[{{ $t('toolkit.comment.deleted') }}]</span></div>
            <div class="flex flex-col text-xs text-gray-500 text-left">
                {{ $t('toolkit.comment.added_by') }} {{comment.auditor_name}} - {{formatDate(props.comment.created_at)}}
                <!--<div v-if="!contains_draft_auditor_comment" style="cursor: pointer;text-decoration: underline;" v-on:click="editAuditorComment();">Edit this post</div>-->
            </div>
        </div>
    </div>

    <JetDialogModal :show="deleteConfirm" @close="closeModal">
            <template #title>
                <span class="text-lg font-bold">{{ $t('toolkit.comment.delete_confirm_title') }}</span>
            </template>

            <template #content>
                {{ $t('toolkit.comment.delete_warning') }}
            </template>

            <template #footer>
                <JetSecondaryButton @click="closeModal">
                    {{ $t('toolkit.comment.delete_cancel') }}
                </JetSecondaryButton>

                <JetButton
                    class="ml-3"
                    @click="deleteComment"
                >
                    {{ $t('toolkit.comment.delete_confirm') }}
                </JetButton>
            </template>
        </JetDialogModal>

</template>
